// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__ZmxiD","logoBox":"Footer_logoBox__tdA5v","termsBox":"Footer_termsBox__7fSWd"};